import React from 'react';
import { useRegisterComponent } from '../../../../orchestrator';
import { useRecaptchaContext } from '../../../../../contexts/recaptcha';
import { useWelcomeState } from '../../hooks';
import { WelcomeRecaptchaContainer } from './styled';

export const WelcomeRecaptcha = () => {
  useRegisterComponent(WelcomeRecaptcha.name);

  const { enabled: recaptchaEnabled, component: recaptchaComponent } = useRecaptchaContext();

  const { state } = useWelcomeState();
  const { recaptchaEnable, shouldSkipCaptcha } = state || {};

  const shouldShow =
    recaptchaEnable && !shouldSkipCaptcha && recaptchaEnabled && recaptchaComponent;

  if (!shouldShow) {
    return null;
  }

  return <WelcomeRecaptchaContainer>{recaptchaComponent}</WelcomeRecaptchaContainer>;
};
